import React, {Component}   from 'react';
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import Container from "@material-ui/core/Container";
import ColAtm from "../../../atomic/Col/Col";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import {Animated} from "react-animated-css";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import PhotoAccordion from "./components/WebEditAccordions";
import {connect} from "react-redux";
import {getEditContentWeb} from "../../../../redux/actions/Web/EditWeb/getEditContentWebActions";
import {updateEditContentWeb, updatePreviewEditContentWeb} from "../../../../redux/actions/Web/EditWeb/updateEditContentWebActions";
import {WEB} from "../../../../constants/appUrls.constants";
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { getProfile } from '../../../../redux/actions/User/Profile/profileAction';

let t =null;

class EditWeb extends Component {
    constructor(props) {
        super(props);
        t = props.t;

        this.state = {
            property_web_id : '',
            open : false,
            showSnackbar: false,
        };
    }

    componentDidMount() {
        this.props.getProfile();

        if ( this.props.match.params.id )
        {
            this.props.getEditContentWeb( { property_web_id : this.props.match.params.id } );

            this.setState({
                property_web_id:this.props.match.params.id
            })
        }
        else{
            this.props.history.replace(WEB);
        }
    }

    handleClickOpen = () => {
        this.setState({open:true});
    };

    handleClose = () => {
        this.setState({open:false});
    };

    handleShowSnackbar = () => {
        this.setState({ showSnackbar: true });
    };

    handleCloseSnackbar = () => {
        this.setState({ showSnackbar: false });
    };

    render() {
        return (
            <>
                <PageTitle title={ t('enw-web-edit_page-page_title') } />
                <PageHeaderAtm exitText={ t('btn-dashboard') } backButton={WEB} text={ t('enw-web-edit-page_title') } />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={this.state.showSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleCloseSnackbar}
                >
                    <Alert onClose={this.handleCloseSnackbar} severity="success">
                        {t('enw-translated_to_all_languages')}
                    </Alert>
                </Snackbar>
                    {
                        !this.props.getEditContentWebReducer.fetching &&
                        <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                            <Container maxWidth="xl">
                                <div className="container-width">
                                    <ColAtm className="edit-web">
                                        <PhotoAccordion
                                            getEditContentWeb={this.props.getEditContentWebReducer}
                                            saveEditContentWeb={this.props.updateEditContentWebReducer}
                                            updateEditContentWeb={this.props.updateEditContentWeb}
                                            updatePreviewEditContentWeb={this.props.updatePreviewEditContentWeb}
                                            handleClickOpen = {this.handleClickOpen}
                                            handleClose = {this.handleClose}
                                            open={this.state.open}
                                            onShowSnackbar={this.handleShowSnackbar}
                                            profileReducer={this.props.profileReducer}
                                        />
                                    </ColAtm>
                                </div>
                            </Container>
                        </Animated>
                    }
            </>
        );
    }
}


const mapStateToProps = (props) => {
    return {
        getEditContentWebReducer : props.getEditContentWebReducer,
        updateEditContentWebReducer: props.updateEditContentWebReducer,
        profileReducer: props.profileReducer
    }
};

const mapDispatchToProps ={
    getEditContentWeb,
    updateEditContentWeb,
    updatePreviewEditContentWeb,
    getProfile
};


export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(EditWeb));
